export default __webpack_public_path__ + "static/Casual-a3dac075d47f67f51bf405e2d42eb821.png";